module.exports = __webpack_public_path__ + "static/media/img2.03eae8a0.jpg";